exports.default = {
  'account_settings': 'Account Settings',
  'nickname': 'Nickname',
  'nickname_placeholder': 'Please enter nickname',
  'add_avatar': 'Add Avatar',
  'email_address': 'Email Address',
  'change_email': 'Change Email',
  'device_management': 'Device Management',
  'device_tip': 'Log out from other devices except this one',
  'logout_all_devices': 'Log out from all devices',
  'device_name': 'Device Name',
  'current_device': 'Current Device',
  'last_active_time': 'Last Active Time',
  'now': 'Now',
  'location': 'Location',
  'logout': 'Logout',
  'delete_my_account': 'Delete My Account',
  'delete_account_tip': 'Permanently delete account and remove access to all workspaces',
  'crop_image': 'Crop Image',
  'need_crop_image': 'Do you need to crop the image?',
  'crop': 'Crop',
  'upload_without_crop': 'Upload without cropping',
  'upload_image': 'Upload Image',
  'cancel': 'Cancel',
  'confirm': 'Confirm',
  'change_email_title': 'Change Email',
  'no_email_tip': 'You have not bound an email yet, please set your email address.',
  'current_email_is': 'Your current email address is:',
  'will_send_code': ', We will send a temporary verification code to this email address.',
  'verification_completed': 'Verification completed',
  'code_sent': 'We have sent a temporary verification code to this email address.',
  'enter_verification_code': 'Please enter verification code',
  'retry_later': 'Retry after {newEmailTimer}s',
  'resend': 'Resend',
  'enter_new_email': 'Please enter a new email address, we will send you a verification code',
  'enter_new_email_placeholder': 'Please enter new email address',
  'verification_tip': 'We just sent a temporary verification code to your email {email}',
  'enter_new_email_code': 'Please enter new email verification code',
  'send_code': 'Send Code',
  'verify': 'Verify',
  'bind_email': 'Bind Email Address',
  'change_email_action': 'Change Email Address',
  'delete_account': 'Delete Account',
  'delete_warning': 'Warning: This operation cannot be undone. After deletion, all your account data will be deleted and you will exit other teams.',
  'confirm_by_email': 'Please enter your email to confirm deletion:',
  'confirm_by_phone': 'Please enter your phone number to confirm deletion:',
  'enter_email_confirm': 'Please enter email to confirm',
  'enter_phone_confirm': 'Please enter phone number to confirm',
  'confirm_delete_account': 'Delete Account',
  'nickname_empty': 'Nickname cannot be empty',
  'save_success': 'Save successful!',
  'image_type_error': 'Image type must be one of: gif, jpeg, jpg, png, bmp',
  'email_required': 'Please enter new email address',
  'email_invalid': 'Please enter a valid email address',
  'email_duplicate': 'New email cannot be the same as current email',
  'code_required': 'Please enter verification code',
  'token_invalid': 'Verification token has expired, please start over',
  'email_bind_success': 'Email bound successfully! Please log in again',
  'email_update_success': 'Email updated successfully! Please log in again',
  'logout_success': 'Logged out of all other devices',
  'operation_failed': 'Operation failed',
  'logout_current_device': 'Logging out current device...',
  'logout_device_success': 'Device logged out successfully',
  'logout_failed': 'Logout failed',
  'email_incorrect': 'Email input is incorrect, unable to delete account',
  'phone_incorrect': 'Phone number input is incorrect, unable to delete account',
  'identity_verification': 'Unable to verify your identity, please bind an email or phone number first',
  'account_deleted': 'Account deleted',
  'delete_account_failed': 'Delete account failed',
  'get_device_list_failed': 'Failed to get device list',
  'account_center': 'Account Center',
  'preferences': 'Preferences',
  'subscription_management': 'Subscription',
  'bill': 'Bill',
  'consumption_records': 'Consumption Records',
  'no_consumption_records': 'No points consumption records',
  'points_details': 'Points Details',
  'points_event': 'Points Event',
  'occurred_at': 'Occurred At',
  'points_change': 'Points Change',
  'points_balance': 'Remaining Points',
  'loading_more': 'Loading more...',
  'no_more_records': 'No more records',
  'points_earned': 'Points Earned',
  'points_expired': 'Points Expired',
  'points_adjusted': 'Points Adjusted',
  'points_consumption': 'Points Consumption',
  'agent_task': 'Agent Task',
  'expand_details': 'Expand Details',
  'collapse_details': 'Collapse Details',
  'refresh_records': 'Refresh records',
  'video_generation': 'Video generation',
  'video_generation_model': 'Video generation · {model}',
  'video_points_reserved': '{points} points on hold, not charged',
  'video_points_committed': 'Hold converted to charge',
  'video_points_released': 'Hold released',
  'video_points_group_held': 'Currently on hold: {points} points',
  'video_points_provisional': 'Provisional charge based on estimate',
  'video_points_refund': 'Difference refunded',
  'video_points_supplemental': 'Additional charge for difference',
  'video_points_adjustment': 'Points adjustment',
  'video_points_settled': 'Settled',
  'date': 'Date',
  'plan_name': 'Plan Name',
  'unpaid': '(Payment incomplete)',
  'amount': 'Amount',
  'invoice': 'Invoice',
  'download_pdf': 'Download PDF',
  'view_receipt': 'View Receipt',
  'downloading': 'Downloading...',
  'loading_bill_failed': 'Failed to load bill',
  'important_info': 'Important Information',
  'membership_expiry': 'After turning off auto-renewal, your membership will expire on {endTime}. After expiration, you will lose the following features:',
  'special_offer': 'Special Offer',
  'discount_info': 'Continue your subscription to enjoy a {discount_percent}% discount for the next year! Discounted price {price} (original price {original_price})',
  'continue_subscription': 'Continue subscription and enjoy discount',
  'reason_prompt': 'Please tell us why you are canceling auto-renewal:',
  'reason_price': 'Price is too high or usage frequency is low',
  'reason_features': 'Features do not meet requirements',
  'reason_alternative': 'Switched to another product',
  'reason_other': 'Other reasons',
  'enter_specific_reason': 'Please enter a specific reason',
  'keep_auto_renewal': 'Keep auto-renewal',
  'confirm_cancel_renewal': 'Confirm cancel auto-renewal',
  'close_subscription_failed': 'Failed to close subscription',
  'return': 'Return',
  'modify_payment': 'Modify Payment Method',
  'add_new_payment': 'Add New Payment Method',
  'payment_update_tip': 'Update your card information to ensure your subscription can be renewed smoothly. The update will not incur any immediate charges.',
  'credit_debit_card': 'Credit Card/Debit Card',
  'card_number': 'Card Number',
  'cardholder_name': 'Cardholder Name',
  'enter_cardholder_name': 'Please enter cardholder name',
  'expiration_date': 'Expiration Date',
  'security_code': 'Security Code',
  'payment_security_warning': 'Your payment information is securely encrypted. Updating card information will not incur immediate charges, it will only be used on the next billing date.',
  'save_payment_method': 'Save Payment Method',
  'stripe_init_failed': 'Stripe initialization failed',
  'payment_component_init_failed': 'Payment component initialization failed: ',
  'unknown_error': 'Unknown error',
  'get_payment_config_failed': 'Failed to get payment configuration',
  'get_payment_key_failed': 'Failed to get payment key',
  'enter_cardholder_name_prompt': 'Please enter cardholder name',
  'enter_valid_card_number': 'Please enter a valid card number',
  'enter_valid_expiry': 'Please enter a valid card expiration date',
  'enter_valid_cvc': 'Please enter a valid security code',
  'create_payment_config_failed': 'Failed to create payment configuration',
  'payment_method_update_success': 'Payment method updated successfully',
  'payment_method_update_failed': 'Payment method update failed, please try again later',
  'payment_success': 'Payment successful',
  'thank_you': 'Thank you for your purchase!',
  'upgrade_success': 'You have successfully upgraded to {verName}',
  'privilege_activated': '{verName} privileges activated',
  'try_now': 'Try Now',
  'choose_plan': 'Choose Plan',
  'plan_description': 'Choose a plan that suits you, you can upgrade or downgrade at any time',
  'yearly': 'Yearly',
  'monthly': 'Monthly',
  'save_percent_planbuy': 'Save {currentDiscount}%',
  'most_popular': 'Popular',
  'recommended': 'Popular',
  'price_period_year': '/year',
  'price_period_month': '/month',
  'selected': 'Selected',
  'select_plan': 'Select {plan}',
  'purchase_title': 'Choose your membership',
  'purchase_subtitle': 'Spend more time creating. Benefits start immediately.',
  'purchase_account_fallback': 'Member account',
  'membership_expires_on': 'Membership expires {expiryDate}',
  'purchase_free_member': 'Free plan',
  'purchase_paid_member': 'Paid member',
  'purchase_domestic': 'Mainland China',
  'purchase_international': 'International',
  'purchase_domestic_note': 'One-time purchase with WeChat or Alipay QR payment',
  'purchase_international_note': 'Monthly and annual subscriptions, cancel anytime',
  'purchase_billing_label': 'Choose billing cycle',
  'purchase_version_label': 'Choose membership version',
  'purchase_period_hint': 'Choose the price that fits your commitment',
  'purchase_benefits_kicker': 'Membership benefits',
  'purchase_period_month': 'Monthly',
  'purchase_period_quarter': 'Quarterly',
  'purchase_period_half_year': 'Half-year',
  'purchase_period_year': 'Yearly',
  'purchase_period_two_year': 'Two-year',
  'purchase_choose_plan': 'Choose the plan that fits',
  'purchase_previous_plan': 'Previous plans',
  'purchase_next_plan': 'Next plans',
  'purchase_single_year': 'Annual',
  'purchase_single_month': 'Monthly',
  'purchase_yearly': 'Annual subscription',
  'purchase_monthly': 'Monthly subscription',
  'purchase_save_badge': 'Best value',
  'purchase_monthly_equivalent': 'Equivalent to',
  'purchase_one_time': 'One-time purchase with no automatic renewal',
  'purchase_auto_renew': 'Auto-renews, cancel anytime',
  'purchase_domestic_footnote': 'Benefits are activated immediately. View your order in Bills.',
  'purchase_international_footnote': 'Secure payments are handled by Stripe. Manage renewals in Account Center.',
  'purchase_selected_plan': 'Selected plan',
  'purchase_owner_only': 'Only the team owner can manage subscriptions. You can still view team plans and points.',
  'purchase_quote_loading': 'Calculating your subscription price…',
  'purchase_quote_failed': 'Could not calculate the amount due. Please retry before subscribing.',
  'purchase_quote_retry': 'Retry',
  'purchase_plan_price': 'Plan price',
  'purchase_credit': 'Credit from your current paid plan',
  'purchase_quote_note': 'Credit applies to the first billing period only. The final amount is recalculated when you place the order; later renewals use the normal plan price.',
  'purchase_select_plan_hint': 'Choose a plan',
  'purchase_pay_now': 'Buy now',
  'purchase_select': 'Select plan',
  'purchase_payment_step': '02 · Payment',
  'purchase_scan_title': 'Scan to pay',
  'purchase_payable': 'Amount due',
  'purchase_scan_description': 'Choose WeChat Pay or Alipay to complete payment. This page updates automatically after payment.',
  'purchase_payment_method': 'Payment method',
  'wechat': 'WeChat Pay',
  'purchase_agreement': 'By paying, you agree to the Membership Service Agreement and Privacy Policy.',
  'purchase_refresh': 'Refresh QR code',
  'purchase_payment_done': 'I have paid',
  'purchase_qr_refreshed': 'QR code refreshed',
  'purchase_self_invoice': 'Self-service invoice',
  'purchase_invoice_help': 'After purchase, open Account Center > Bills to issue an invoice.',
  'purchase_payment_channels_failed': 'Failed to load available payment methods',
  'purchase_no_payment_channel': 'No payment method is currently available. Please try again later.',
  'purchase_no_plan': 'No membership plans are currently available',
  'purchase_no_matching_plan': 'No matching plans are available right now',
  'purchase_qr_loading': 'Generating payment QR code',
  'purchase_payment_pending': 'Payment has not been confirmed yet. Complete payment and try again.',
  'purchase_fuel_packages': 'Buy Fuel Package',
  'purchase_fuel_packages_note': 'Fuel package points are added separately',
  'purchase_buy_now': 'Buy Now',
  'purchase_renew_now': 'Renew Now',
  'purchase_upgrade_now': 'Upgrade Now',
  'purchase_subscribe_now': 'Subscribe Now',
  'purchase_no_fuel_packages': 'No fuel packages are currently available',
  'proceed_to_payment': 'Proceed to Payment',
  'repay': 'Repay',
  'unfinished_payment_tips': 'Payment is not yet complete, please click "Repay" to continue. If you need help, please contact customer service.',
  'select_plan_prompt': 'Please select a plan',
  'processing_payment': 'Processing payment...',
  'get_plan_id_failed': 'Failed to get plan ID',
  'create_payment_session_failed': 'Failed to create payment session',
  'payment_error': 'Error occurred during payment',
  'payment_status_timeout': 'Payment status query timeout',
  'order_cancelled': 'Order cancelled',
  'query_order_failed': 'Failed to query order information',
  'appearance': 'Appearance',
  'theme_customization': 'Customize system theme color',
  'language': 'Language',
  'change_language': 'Change user interface language',
  'config_load_failed': 'Configuration loading failed',
  'user_settings_load_failed': 'User settings loading failed',
  'save_failed': 'Save failed',
  'free_desc': 'The free version provides basic functionality, upgrade to the paid version to unlock more advanced features and higher usage limits.',
  'upgrade': 'Upgrade',
  'buy_points': 'Buy Points',
  'points_usage': 'Points Usage',
  'storage_usage': 'Storage Usage',
  'points_quota_tip': '{points_quota_used_numerical}/{points_quota_total_numerical} points',
  'storage_quota_tip': 'Total {storage_quota_total_numerical}GB, remaining {storage_quota_surplus_numerical}GB',
  'all_plans': 'All Plans',
  'current_tag': 'Current Plan',
  'current_plan': 'Current Plan',
  'save_percent': 'Save {currentPriceInfo}%',
  'valid_status': 'Valid',
  'expiring_status': 'Expiring Soon',
  'subscription_active': 'Your annual subscription is active, auto-renewal is enabled.',
  'auto_renewal_off': 'You have turned off auto-renewal. You can continue to use all features until your subscription expires.',
  'subscription_expiry_warning': 'Your subscription will expire on {endTime}. After expiration, you will lose all privileges.',
  'restore_subscription': 'Restore Subscription',
  'subscription_period': 'Subscription Period',
  'next_payment_date': 'Next Payment Date',
  'next_payment_amount': 'Next Payment Amount',
  'subscription_status': 'Subscription Status',
  'auto_renewal_on': 'Enabled',
  'auto_renewal_off_status': 'Disabled',
  'expires_on': 'Expires on {expiryDate}',
  'card_expired': 'Expired',
  'change': 'Change',
  'card_expiry_warning': 'Your payment card has expired. To ensure uninterrupted service, please update to a valid payment method. This will not incur immediate charges,',
  'next_payment_notice': 'it will only be used on your next renewal cycle on {nextPaymentDate}.',
  'auto_renewal_status_on': 'Auto-renewal Enabled',
  'auto_renewal_status_off': 'Auto-renewal Disabled',
  'renewal_on_details': 'Auto-renewal is enabled. Your membership will renew on {nextPaymentDate}, and you will be charged an annual fee of {nextPaymentAmount}',
  'renewal_off_details': 'Auto-renewal is disabled. Your membership will expire on {endTime}. Enable auto-renewal to continue enjoying all privileges.',
  'upgrade_plan': 'Upgrade Plan',
  'current_benefits': 'Current Benefits',
  'highest_version': 'You have already upgraded to the highest version',
  'light': 'Light',
  'dark': 'Dark',
  'system': 'System',
  'alipay': 'Alipay',
  // Points Management
  'points_management': 'Points Management',
  'total_points': 'Total Points',
  'subscription_points': 'Subscription Points',
  'purchased_points': 'Purchased Points',
  'activity_points': 'Activity Points',
  'buy_points_packages': 'Buy Points Packages',
  'buy_now': 'Buy Now',
  'points_package': 'Points Package',
  'get_points_info_failed': 'Failed to get points info',
  'get_package_list_failed': 'Failed to get package list'
}
